module.exports = __webpack_public_path__ + "static/media/amazon-light-mode.d33c369a.png";